import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ExemptionsAdd,
  ExemptionsRecord
} from '../types/reports/refuel-report';

@Injectable({
  providedIn: 'root',
})
export class ExemptionService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<ExemptionsRecord[]> {
    return this.http.get<ExemptionsRecord[]>(
      '/api/exemption'
    );
  }

  add(
    exemptionsRecord: ExemptionsAdd
  ): Observable<void> {
    return this.http.post<any>('api/exemption', exemptionsRecord);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<any>(`api/exemption/${id}`)
  }
}
